import { siteData } from "../data/mock";
import { Star } from "lucide-react";

export const SocialProof = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-14">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-3">
            O Que Nossos Pacientes Dizem
          </h2>
          <p className="text-lg text-slate-500 max-w-xl mx-auto">
            Mais de {siteData.hero.socialProof.reviews} pacientes satisfeitos em Chapecó
          </p>
        </div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {siteData.reviews.map((review) => (
            <div
              key={review.id}
              className="rounded-xl bg-white border-2 border-slate-100 p-6 hover:border-[#85BCFF] hover:shadow-lg transition-all duration-300"
            >
              <div className="flex mb-3">
                {Array.from({ length: review.rating }).map((_, i) => (
                  <Star key={i} size={18} fill="#85BCFF" style={{ color: '#85BCFF' }} />
                ))}
              </div>
              <p className="text-slate-700 mb-4 text-sm leading-relaxed italic">
                "{review.text}"
              </p>
              <p className="font-semibold text-sm text-slate-900">{review.name}</p>
            </div>
          ))}
        </div>

        {/* Google Rating Summary */}
        <div className="mt-10 flex justify-center">
          <div className="inline-flex items-center gap-3 bg-slate-50 px-6 py-3 rounded-full">
            <div className="flex gap-0.5">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} size={16} fill="#85BCFF" style={{ color: '#85BCFF' }} />
              ))}
            </div>
            <span className="text-sm font-semibold text-slate-700">
              {siteData.hero.socialProof.rating} no Google — {siteData.hero.socialProof.reviews} avaliações
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};
